import { PartsManagerPage } from "./PartsManagerPage";

const PartsManager = () => {
	return <PartsManagerPage />;
};

export default PartsManager;
